module.exports = __webpack_public_path__ + "img/hub_music.7f9cd377.svg";